<template>
  <div class="anz-bg-black-3 anz-p-xl anz-my-xl anz-align-center">
    <h6 class="anz-fs-xs anz-color-primary">
      {{ configuration.extSysConf.disableText }}
    </h6>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useConfiguration from '@/composables/configuration/configuration'

export default defineComponent({
  name: 'TechnicalShutdown',
  setup() {
    return {
      ...useConfiguration(),
    }
  },
})
</script>
